module.exports = "<div class=\"form-group\" data-designerId=\"email\">\r\n    <label for=\"email\">{{'EMAIL' | i18next}}</label>\r\n    <input type=\"email\" id=\"email\" [(ngModel)]=\"controlContext.email\" />\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/deprecated/email.designer.component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/designers/layout/deprecated/email.designer.component.html
// module chunks = main